import BaseLayer from "./BaseLayer";
import {plotDisagreementv2Unit, plotStitchingErrorLeft, plotStitchingErrorTop} from "../utils/map_utils";

class StitchingError extends BaseLayer {

    id = "stitchingError";
    label = "Stitching Error";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchingError, textColor} = this.props;
        console.debug('_stitchingError', stitchingError);
        let maxScore = 0;
        let minScore = 100000000; // some large number
        for (const tPairScore of stitchingError['score_list_t']) {
            const score = Math.floor(tPairScore[2] * 100.0) / 100.0;
            if (score > maxScore) {
                maxScore = score;
            }
            if (score < minScore) {
                minScore = score;
            }
        }
        for (const tPairScore of stitchingError['score_list_l']) {
            const score = Math.floor(tPairScore[2] * 100.0) / 100.0;
            if (score > maxScore) {
                maxScore = score;
            }
            if (score < minScore) {
                minScore = score;
            }
        }

        for (const tPairScore of stitchingError['score_list_t']) {
            console.log(tPairScore);
            const key = tPairScore[0];
            const score = Math.floor(tPairScore[2] * 100.0) / 100.0;
            const margin = 3 / 10;
            const sizeOfMarker = 0.2;
            const xHori = parseInt(key.split('y')[0].split('x')[1]);
            const yVerti = parseInt(key.split('y')[1].split('.' + this.props.slide.img_type)[0]);
            plotStitchingErrorTop(score, maxScore, minScore, this.props.slide, xHori, yVerti, margin, sizeOfMarker, this.layer.getSource(), textColor);
        }

        for (const tPairScore of stitchingError['score_list_l']) {
            console.log(tPairScore);
            const key = tPairScore[0];
            const score = Math.floor(tPairScore[2] * 100.0) / 100.0;
            const margin = 3 / 10;
            const sizeOfMarker = 0.2;
            const xHori = parseInt(key.split('y')[0].split('x')[1]);
            const yVerti = parseInt(key.split('y')[1].split('.' + this.props.slide.img_type)[0]);
            plotStitchingErrorLeft(score, maxScore, minScore, this.props.slide, xHori, yVerti, margin, sizeOfMarker, this.layer.getSource(), textColor);
        }
        resolve();
    });
}

export default StitchingError;
